import { render, staticRenderFns } from "./research-date.vue?vue&type=template&id=32d2b380&scoped=true&"
import script from "./research-date.vue?vue&type=script&lang=js&"
export * from "./research-date.vue?vue&type=script&lang=js&"
import style0 from "./research-date.vue?vue&type=style&index=0&id=32d2b380&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d2b380",
  null
  
)

export default component.exports